import React from 'react';
import { clsx } from 'clsx';
import { IProps } from '@/elements/Image/Image.interface';
import '@/elements/Image/Image.styles.css';

const Image: React.FC<IProps> = ({
    alternateText,
    sizesAttribute,
    defaultSrc,
    srcSet,
    className,
    loadingType = 'lazy',
    rounded = false,
}) => {
    const sizes = sizesAttribute?.join(', ');
    const sources = srcSet?.map((srcEntry, index) => {
        // Basic parsing assuming format 'url widthDescriptor'
        const [url, width] = srcEntry.split(' ');
        // Extract media query from sizesAttribute if available, otherwise create a basic one
        const media = sizesAttribute?.[index] ? `(${sizesAttribute[index]})` : `(max-width: ${width?.replace('w', 'px')})`;
        return <source key={`image-source-${defaultSrc}-${index}`} media={media} srcSet={url} />;
    });

    return (
        <picture className={clsx('image', rounded && 'image--rounded', className)}>
            {sources}
            <img src={defaultSrc} alt={alternateText} sizes={sizes} loading={loadingType} />
        </picture>
    );
};

export default Image;
